import { Link, useLocation } from "react-router-dom";

export default function Navigation({ onMobileMenuClose }) {
  const location = useLocation();

  const handleLinkClick = () => {
    if (onMobileMenuClose) {
      onMobileMenuClose();
    }
  };

  return (
    <nav className="flex-1">
      <ul className="list-none p-0 m-0 max-md:space-y-4">
        <li className="mb-6 max-md:mb-4">
          <Link
            to="/"
            onClick={handleLinkClick}
            className={`text-black no-underline text-lg tracking-wide transition-all duration-200 hover:opacity-60 relative max-md:text-xl max-md:block max-md:py-2 max-md:px-4 max-md:rounded-md max-md:hover:bg-gray-100 ${
              location.pathname === "/" ? "opacity-60" : ""
            }`}
          >
            bio
          </Link>
        </li>
        <li className="mb-6 max-md:mb-4">
          <Link
            to="/works"
            onClick={handleLinkClick}
            className={`text-black no-underline text-lg tracking-wide transition-all duration-200 hover:opacity-60 relative max-md:text-xl max-md:block max-md:py-2 max-md:px-4 max-md:rounded-md max-md:hover:bg-gray-100 ${
              location.pathname === "/works" ? "opacity-60" : ""
            }`}
          >
            works
          </Link>
        </li>
        <li className="mb-6 max-md:mb-4">
          <Link
            to="/press"
            onClick={handleLinkClick}
            className={`text-black no-underline text-lg tracking-wide transition-all duration-200 hover:opacity-60 relative max-md:text-xl max-md:block max-md:py-2 max-md:px-4 max-md:rounded-md max-md:hover:bg-gray-100 ${
              location.pathname === "/press" ? "opacity-60" : ""
            }`}
          >
            press
          </Link>
        </li>
        <li className="mb-6 max-md:mb-4">
          <Link
            to="/contact"
            onClick={handleLinkClick}
            className={`text-black no-underline text-lg tracking-wide transition-all duration-200 hover:opacity-60 relative max-md:text-xl max-md:block max-md:py-2 max-md:px-4 max-md:rounded-md max-md:hover:bg-gray-100 ${
              location.pathname === "/contact" ? "opacity-60" : ""
            }`}
          >
            contact
          </Link>
        </li>
      </ul>
    </nav>
  );
}
